import gql from 'graphql-tag';

export default gql`
  mutation updateHomeTaskFileStatusMutation($lessonId: MongoID!, $fileId: MongoID!, $status: String!) {
    updateHomeTaskFileStatusMutation(lessonId: $lessonId, fileId: $fileId, status: $status) {

      _id
      id
      title
      data {
        student
        course
        courseCategory
        homeTaskStatus
        isZeroLesson
      }
      workOnHomeTask {
        notes
      }
      homeTask {
        _id
        title
        notes
        filesStatuses {
          file
          status
          updatedAt
          updatedBy
        }
        files {
          _id
          name
          description
          interactionIcon
          path
          type
          data {
            isNotHandout
            isLink
          }
        }
      }

    }
  }
`;
